export let MediaOrientation = /*#__PURE__*/function (MediaOrientation) {
  MediaOrientation["Portrait"] = "PORTRAIT";
  MediaOrientation["Square"] = "SQUARE";
  MediaOrientation["Landscape"] = "LANDSCAPE";
  return MediaOrientation;
}({});
//# sourceMappingURL=types.js.map